import React from "react";
import Home from "../Home/Home";
import { Card, CardBody, CardHeader, CardText, Col, Row } from "reactstrap";

const Dashboard = () => {
  return (
    <div>
      <Home />
      <div>
        ladsj
      </div>
      {/* <div className="form-container">
        <div className="form-align">
          <h3>Current Month Data</h3>
          <br />
          <h4>Call </h4>
          <Row>
            <Col md={6} lg={3} sm={12}>
              <Card className="dashboard-card my-2 ">
                <CardHeader className="dashboard-card-header">
                  No. of Calls Given
                </CardHeader>
                <CardBody className="dashboard-cardbody">
                  <CardText>123344 </CardText>
                </CardBody>
              </Card>
            </Col>
            <Col md={6} lg={3} sm={12}>
              <Card className="dashboard-card  my-2 ">
                <CardHeader className="dashboard-card-header">
                  No. of Target Hit
                </CardHeader>
                <CardBody className="dashboard-cardbody">
                  <CardText>122344</CardText>
                </CardBody>
              </Card>
            </Col>
            <Col md={6} lg={3} sm={12}>
              <Card className="dashboard-card my-2 ">
                <CardHeader className="dashboard-card-header">
                  No. of Stop loss Hit
                </CardHeader>
                <CardBody className="dashboard-cardbody">
                  <CardText>123344</CardText>
                </CardBody>
              </Card>
            </Col>
            <Col md={6} lg={3} sm={12}>
              <Card className="dashboard-card my-2 ">
                <CardHeader className="dashboard-card-header">
                  No. of Executed Call
                </CardHeader>
                <CardBody className="dashboard-cardbody">
                  <CardText>123344</CardText>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <br />

          <h4>Top 5 performing Product/Service </h4>
          <table id="userTable" className="display" style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Product Name</th>
                <th>Product ID</th>
                <th>Type</th>
              </tr>
            </thead>
            <tr>
              <th>1</th>
              <th>Arc</th>
              <th>Pro1</th>
              <th>product</th>
            </tr>
            <tbody />
          </table>

          <br />
          <h4>Client </h4>
          <Row>
            <Col md={6} lg={3} sm={12}>
              <Card className="dashboard-card my-2 ">
                <CardHeader className="dashboard-card-header">
                  No. of Client
                </CardHeader>
                <CardBody className="dashboard-cardbody">
                  <CardText>123344</CardText>
                </CardBody>
              </Card>
            </Col>
            <Col md={6} lg={3} sm={12}>
              <Card className="dashboard-card my-2 ">
                <CardHeader className="dashboard-card-header">
                  No. of Active Client
                </CardHeader>
                <CardBody className="dashboard-cardbody">
                  <CardText>123344</CardText>
                </CardBody>
              </Card>
            </Col>
            <Col md={6} lg={3} sm={12}>
              <Card className="dashboard-card my-2 ">
                <CardHeader className="dashboard-card-header">
                  No. of Expiry in current Month
                </CardHeader>
                <CardBody className="dashboard-cardbody">
                  <CardText>123344</CardText>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <br />
          <h4>Other</h4>
          <Row>
            <Col md={6} lg={3} sm={12}>
              <Card className="dashboard-card my-2 ">
                <CardHeader className="dashboard-card-header">
                  No. of Review
                </CardHeader>
                <CardBody className="dashboard-cardbody">
                  <CardText>123344</CardText>
                </CardBody>
              </Card>
            </Col>
            <Col md={6} lg={3} sm={12}>
              <Card className="dashboard-card my-2 ">
                <CardHeader className="dashboard-card-header">
                  No. of Complain
                </CardHeader>
                <CardBody className="dashboard-cardbody">
                  <CardText>123344</CardText>
                </CardBody>
              </Card>
            </Col>
            <Col md={6} lg={3} sm={12}>
              <Card className="dashboard-card my-2 ">
                <CardHeader className="dashboard-card-header">
                  No. of
                </CardHeader>
                <CardBody className="dashboard-cardbody">
                  <CardText>123344</CardText>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <br />
          <h4>Sales</h4>
          <Row>
            <Col md={6} lg={3} sm={12}>
              <Card className="dashboard-card my-2 ">
                <CardHeader className="dashboard-card-header">
                  Sum of Sales
                </CardHeader>
                <CardBody className="dashboard-cardbody">
                  <CardText>123344</CardText>
                </CardBody>
              </Card>
            </Col>
            <Col md={6} lg={3} sm={12}>
              <Card className="dashboard-card my-2 ">
                <CardHeader className="dashboard-card-header">
                  Sum of Due Amount
                </CardHeader>
                <CardBody className="dashboard-cardbody">
                  <CardText>123344</CardText>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <br />
          <h4>Product</h4>
          <Row>
            <Col md={6} lg={3} sm={12}>
              <Card className="dashboard-card my-2 ">
                <CardHeader className="dashboard-card-header">
                  Most Subscribed Product/Service
                </CardHeader>
                <CardBody className="dashboard-cardbody">
                  <CardText>123344</CardText>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div> */}
    </div>
  );
};

export default Dashboard;
